var ko = require('knockout'),
  APIHelper = require('_js/APIHelper'),
  cloneDeep = require('lodash/cloneDeep'),
  decodeHtml = require('_utils/text');
require('knockout-postbox');

function ExternalCourse(params) {
  this.API = params.api;
  this.params = params;

  this.title = ko.observable(decodeHtml(params.title));
  this.organizer = ko.observable(decodeHtml(params.organizer));

  this.fromDate = ko.observable(params.fromDate);
  this.categories = ko.observableArray(
    ko.utils.arrayMap(params.categories, function(category) {
      var tmpCategory = cloneDeep(category);
      tmpCategory.Hours = ko.observable(tmpCategory.Hours);
      return tmpCategory;
    })
  );
}

ExternalCourse.prototype.init = function(element) {
  this.$element = $(element);
  this.$htmlBody = $('html, body');
  this.editCourseEl = this.$element.siblings('.calculator-extended-course');
  this.showEditCourse = ko.observable(false);
};

ExternalCourse.prototype.updateCourseValues = function(params) {
  this.title(decodeHtml(params.title));
  this.organizer(decodeHtml(params.organizer));
  this.fromDate(params.fromDate);

  this.categories(
    ko.utils.arrayMap(params.categories, function(category) {
      var tmpCategory = cloneDeep(category);
      tmpCategory.Hours = ko.observable(tmpCategory.Hours);
      return tmpCategory;
    })
  );
  this.categories.valueHasMutated();
};

ExternalCourse.prototype.toggleAddCourse = function() {
  this.toggleEditCourse();
};

ExternalCourse.prototype.toggleEditCourse = function() {
  var self = this;
  if (this.showEditCourse()) {
    this.editCourseEl.slideUp(250, 'easeOutQuad');
    this.showEditCourse(false);
  } else {
    this.editCourseEl.slideUp(250, 'easeOutQuad', function() {
      self.editCourseEl.slideDown(250, 'easeOutQuad', function() {
        // Get the position and subtract the padding.
        var scrollToTarget = self.editCourseEl.offset().top - 100;
        self.$htmlBody.animate({ scrollTop: scrollToTarget + 'px' });
      });
      self.showEditCourse(true);
    });
  }
};

ExternalCourse.prototype.removeCourse = function() {
  var self = this;
  APIHelper.delete(
    this.API.removeCourseApi + '/' + this.params.sequencePk,
    undefined,
    function() {
      self.editCourseEl.slideUp(250, 'easeOutQuad');
      self.showEditCourse(false);
      self.$element.slideUp();
    }
  );
};

ExternalCourse.prototype.editCourse = function() {};

module.exports = ExternalCourse;
